<script lang="ts">
  import PageLayout from "../../pages/layout/PageLayout.svelte";
  import AuthFormHeader from "../auth/common/AuthFormHeader.svelte";
  import AuthFormStyle from "../auth/common/AuthFormStyle.svelte";
  import Icon from "../common/icons/Icon.svelte";
  import checkMobileDevice from "../common/is-mobile";
  import EnterWaitlist from "../common/enter-waitlist/EnterWaitlist.svelte";

  const isMobile = checkMobileDevice();
</script>

<PageLayout hasBgGradient={true} hasFooter={false}>
  <div class="auth-form-container" style="margin: 10px 0px">
    <div class="form-content">
      <AuthFormHeader title="Restricted" />

      <div
        class="flex flex-row items-center py-2.5 px-5 gap-2.5 rounded-md bg-tertiary-orange bg-opacity-10"
      >
        <div><Icon icon="login-message-lock" size="32px" /></div>

        <div class="text-tertiary-orange">
          Datadocs is currently in development, and access is not yet public.
          The page you are looking for is either restricted or could not be
          found.
        </div>
      </div>

      <div
        class="{isMobile ? '-mx-7' : '-mx-10'} mt-5 mb-6 h-px bg-light-100"
      />

      <div class="join-the-waitlist">
        <div class="text-center text-[18px] font-medium text-dark-300 mb-2">
          Join the Waitlist
        </div>

        <div
          class="text-center text-[12px] font-medium text-dark-50 text-opacity-80 mb-4"
        >
          to get updates on the product.
        </div>

        <EnterWaitlist
          useIconButton={false}
          hasInputBorder={true}
          inputBoxShadow={false}
          successBoxShadow={true}
          orientation="vertical"
        />
      </div>
    </div>
  </div>
</PageLayout>

<AuthFormStyle />
